import { render, staticRenderFns } from "./SchemaFrom.vue?vue&type=template&id=0f69f584&"
import script from "./SchemaFrom.vue?vue&type=script&lang=js&"
export * from "./SchemaFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports